const displayHealthClaims = () => {
	const healthClaimsElement = document.querySelector('[data-js-health-claims]');
	if (!healthClaimsElement) return;

	const footerWrapperElement = document.querySelector('.footer__wrapper');
	const footerAsideElement = document.querySelector('.footer__aside');
	const footerPaymenIconsElement = footerWrapperElement.querySelector('.footer__payment-icons');
	const footerCopyrightElement = footerWrapperElement.querySelector('.footer__copyright');

	const newHealthClaimsElementDesktop = healthClaimsElement.cloneNode(true);
	const newHealthClaimsElementMobile = healthClaimsElement.cloneNode(true);

	newHealthClaimsElementDesktop.classList.add('footer__health-claims--desktop');
	footerAsideElement.appendChild(newHealthClaimsElementDesktop);

	newHealthClaimsElementMobile.classList.add('footer__health-claims--mobile');
	footerPaymenIconsElement.after(newHealthClaimsElementMobile);
};

document.addEventListener('DOMContentLoaded', displayHealthClaims);
